<script setup lang="ts">
import LoginForm from "@/components/form/LoginForm.vue"
import { useNavbarState } from "@/stores"
import { useRoute } from "vue-router"

const navbarState = useNavbarState()
const route = useRoute()
</script>

<template>
    <LoginForm
        class="container d-flex align-items-lg-center flex-column flex-lg-row"
        :redirect="route.meta?.redirectAfterLogin !== false"
        @success="navbarState.openCard(null)"
    />
</template>
